export enum ECartRequestName {
  DELETE_PRODUCT_FROM_CART = 'deleteProductFromCart',
  CHANGE_PRODUCT_QUANTITY = 'changeProductQuantity',
  CLEAR_CART = 'clearCart',
  ADD_PRODUCT_TO_CART = 'addProductToCart',
}
